import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from "antd";
import { Button } from "../../components/button/Button";
import DEATH_API from "../../apis/death.api";
import { useDispatch, useSelector } from "react-redux";
import { setActivated } from "../../redux/slices/loginSlice";
import swal from "sweetalert";

const DelegateAccess = () => {
  const activated = useSelector(
    (state) => state.rootReducer.loginUser.activated
  );
  console.log("activated", activated);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [trusteeList, setTrusteeList] = useState([]);
  const [inviteList, setInviteList] = useState([]);
  const [accessableUsers, setAccessableUsers] = useState([]);
  const pendingRequestsRef = useRef(0);
  const isInitialLoading =
    loading &&
    trusteeList.length === 0 &&
    inviteList.length === 0 &&
    accessableUsers.length === 0;

  const updateLoading = (isLoading) => {
    pendingRequestsRef.current = isLoading
      ? pendingRequestsRef.current + 1
      : Math.max(pendingRequestsRef.current - 1, 0);

    setLoading(pendingRequestsRef.current > 0);
  };

  const getParsedStorageValue = (key) => {
    const value = localStorage.getItem(key);

    if (!value || value === "undefined") {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  };

  useEffect(() => {
    getClientList();
    if (
      getParsedStorageValue("role") === "activeClient" ||
      getParsedStorageValue("duplicateRole") === "activeClient"
    ) {
      getContactList();
    }
  }, []);
  const getClientList = async () => {
    updateLoading(true);
    try {
      let responseData = await DEATH_API.fetchClientList();
      let newData = [];
      if (
        responseData.data &&
        responseData.data[0] &&
        responseData.data[0].users
      ) {
        const accessId = localStorage.getItem("accessId");
        newData = responseData.data[0].users.map((item) => ({
          ...item,
          Status: String(item.id) === String(accessId),
        }));
      }
      localStorage.setItem("delegateUsers", JSON.stringify(newData));
      setAccessableUsers(newData);
      if (
        responseData.data &&
        responseData.data[0] &&
        responseData.data[0].invitedBy
      ) {
        setInviteList(responseData.data[0].invitedBy);
      } else {
        setInviteList([]);
      }
      if (isNaN(localStorage.getItem("User"))) {
        console.log("not a number in username");
      }
    } catch (error) {
      console.log("error");
    } finally {
      updateLoading(false);
    }
  };
  const getContactList = async () => {
    updateLoading(true);
    try {
      let apiResponse = await DEATH_API.getPeopleWithAccess();
      console.log("apiResponse", apiResponse);
      setTrusteeList([]);
      if (
        apiResponse &&
        apiResponse.invited &&
        apiResponse.invited[0] &&
        apiResponse.invited[0].contacts
      ) {
        setTrusteeList(apiResponse.invited[0].contacts);
      }
    } catch (error) {
      console.log(error);
    } finally {
      updateLoading(false);
    }
  };
  const deleteTrusteeAccess = async (id, trusteeId) => {
    let payload = {
      contactId: id,
      trusteeId: trusteeId,
    };
    swal({
      title: "Are you sure?",
      text: "You want to delete this Trustee.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        updateLoading(true);
        try {
          const resposnse = await DEATH_API.cancelTrusteeAccess(payload);
          if (resposnse && resposnse.status === 200) {
            await getContactList();
            swal("Success", resposnse.message, "success");
          }
        } catch (error) {
          console.log(error);
        } finally {
          updateLoading(false);
        }
      } else {
        swal("Cancelled", "Your Trustee is safe :)", "error");
      }
    });
  };

  useEffect(() => {
    getClientList();
    console.log("useEffect activated", activated);
  }, [activated]);

  const handleClick = (id) => {
    console.log("id", id);
    const updatedUsers = accessableUsers.map((item) => ({
      ...item,
      Status: String(id) === String(item.id),
    }));
    setAccessableUsers(updatedUsers);
    localStorage.setItem("delegateUsers", JSON.stringify(updatedUsers));
  };
  const handleAccept = async (code) => {
    console.log("Accepted");
    updateLoading(true);
    try {
      let responseData = await DEATH_API.acceptInvitation(code);
      console.log("responseData", responseData);
      if (responseData && responseData.status === 200) {
        swal("Success", responseData.message, "success");
        await getClientList();
      }
    } catch (error) {
      console.log("error");
    } finally {
      updateLoading(false);
    }
  };

  const renderLoadingCards = (count = 2) => {
    const skeletonBlockStyle = {
      borderRadius: "999px",
      background:
        "linear-gradient(90deg, #eef2ff 20%, #ffffff 50%, #eef2ff 80%)",
      backgroundSize: "200% 100%",
      animation: "delegateSkeletonPulse 1.4s ease-in-out infinite",
    };

    return Array.from({ length: count }, (_, index) => (
      <Col
        key={`loading-card-${index}`}
        className="DelegateCard"
        style={{
          border: "1px solid rgba(42, 61, 163, 0.08)",
          boxShadow: "0 12px 30px rgba(25, 38, 86, 0.08)",
          borderRadius: "16px",
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(247, 249, 255, 0.98))",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1.5rem",
            }}
          >
            <div
              style={{
                height: "18px",
                width: "42%",
                ...skeletonBlockStyle,
              }}
            />
            <div
              style={{
                height: "34px",
                width: "118px",
                borderRadius: "10px",
                ...skeletonBlockStyle,
              }}
            />
          </div>
          <div
            style={{
              height: "14px",
              width: "58%",
              marginBottom: "1rem",
              ...skeletonBlockStyle,
            }}
          />
          <div
            style={{
              height: "16px",
              width: "72%",
              marginBottom: "0.75rem",
              ...skeletonBlockStyle,
            }}
          />
          <div
            style={{
              height: "16px",
              width: "48%",
              marginBottom: "1.75rem",
              ...skeletonBlockStyle,
            }}
          />
          <div
            style={{
              marginTop: "auto",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                height: "12px",
                width: "26%",
                ...skeletonBlockStyle,
              }}
            />
            <div
              style={{
                height: "36px",
                width: "132px",
                borderRadius: "10px",
                ...skeletonBlockStyle,
              }}
            />
          </div>
        </div>
      </Col>
    ));
  };

  return (
    <div>
      <style>
        {`
          @keyframes delegateSkeletonPulse {
            0% {
              background-position: 200% 0;
            }
            100% {
              background-position: -200% 0;
            }
          }
        `}
      </style>
      <div className="asset-heading" style={{ background: "#2A3DA3" }}>
        <Row style={{ textAlign: "center" }}>
          <div>
            <h2 style={{ color: "white" }} className=" font-weight">
              Delegate Access
            </h2>
          </div>
        </Row>
      </div>
      <Row style={{ textAlign: "center" }}>
        {((localStorage.getItem("duplicateRole") &&
          getParsedStorageValue("duplicateRole") === "activeClient") ||
          getParsedStorageValue("role") === "activeClient") && (
          <Button
            style={{ width: "30%", background: "#2A3DA3" }}
            onClick={() => {
              console.log("My account");
              if (localStorage.getItem("accessId")) {
                localStorage.removeItem("accessId");
                localStorage.removeItem("financialAccess");
              }
              if (localStorage.getItem("duplicateRole")) {
                localStorage.setItem(
                  "role",
                  localStorage.getItem("duplicateRole")
                );
              }
              localStorage.removeItem("duplicateRole");
              getClientList();
              dispatch(setActivated(!activated));
            }}
          >
            My Account
          </Button>
        )}
      </Row>

      <div style={{ minHeight: "320px" }}>
        {loading && (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.75rem",
              margin: "0 0 1rem 0.5rem",
              padding: "0.6rem 0.95rem",
              borderRadius: "999px",
              background: "rgba(248, 250, 255, 0.95)",
              border: "1px solid rgba(42, 61, 163, 0.1)",
              color: "#4b5680",
              fontWeight: 500,
              fontSize: "13px",
              boxShadow: "0 6px 18px rgba(31, 45, 97, 0.06)",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                background: "#2A3DA3",
                boxShadow: "0 0 0 5px rgba(42, 61, 163, 0.12)",
              }}
            />
            Loading delegate access
          </div>
        )}

        <Row
          gutter={[16, 16]}
          className="RowContainer"
          style={{
            justifyContent: "space-between",
            opacity: isInitialLoading ? 1 : loading ? 0.72 : 1,
            transition: "opacity 0.25s ease",
          }}
        >
        {/* LEFT BOX */}
        <Col
          xs={24}
          sm={12}
          lg={12}
          xl={12}
          style={{ display: "flex", width: "45%" }}
        >
          <Row className="DelegateSection">
            <Col style={{ height: "auto" }}>
              <p className="left-black">People With Access to My Account</p>
            </Col>
            {isInitialLoading
              ? renderLoadingCards()
              : trusteeList &&
              trusteeList.map(
                (item, index) =>
                  item.isTrusted && (
                    <Col key={index} className="DelegateCard">
                      <div className="DelegateClientSection">
                        <p className="DelegateHeading">
                          {item.firstName ? item.firstName : ""}{" "}
                          {item.lastName ? item.lastName : ""}
                        </p>
                      </div>
                      <div className="DelegateClientSection">
                        <p className="DelegateHeading">
                          Module I have Granted Access
                        </p>
                      </div>
                      <p
                        className="DelegateSubHeading"
                        style={{ margin: "2rem 2rem" }}
                      >
                        Death (When I Die)
                      </p>
                      <div
                        style={{ marginTop: "8px" }}
                        className="DelegateClientSection"
                      >
                        <p
                          style={{
                            fontWeight: "500",
                            fontSize: "18px",
                            color: "green",
                          }}
                        ></p>
                        <Button
                          style={{
                            width: "fit-content",
                            background: "#E65E42",
                          }}
                          onClick={() => {
                            if (
                              item.invites &&
                              item.invites[0] &&
                              item.invites[0].trusteeUserId
                            ) {
                              deleteTrusteeAccess(
                                item.id,
                                item.invites[0].trusteeUserId
                              );
                            }
                          }}
                        >
                          Cancel Now
                        </Button>
                      </div>
                    </Col>
                  )
              )}
          </Row>
        </Col>

        {/* RIGHT BOX */}
        <Col
          xs={24}
          sm={12}
          lg={12}
          xl={12}
          style={{ display: "flex", width: "45%" }}
        >
          <Row className="DelegateSection">
            <Col style={{ height: "auto" }}>
              <p className="left-black">Accounts I Have Access To</p>
            </Col>
            {isInitialLoading
              ? renderLoadingCards()
              : accessableUsers &&
              accessableUsers.map((item, index) => (
                <Col key={index} className="DelegateCard">
                  <div className="DelegateClientSection">
                    <p className="DelegateHeading">{item.name}</p>
                  </div>
                  <div className="DelegateClientSection">
                    <p className="DelegateHeading">Modules I Can Access</p>
                  </div>
                  <p
                    className="DelegateSubHeading"
                    style={{ margin: "2rem 2rem" }}
                  >
                    Death (When I Die)
                  </p>
                  <div
                    className="DelegateClientSection"
                    style={{ marginTop: "8px" }}
                  >
                    {!item.Status ? (
                      String(item.id) === String(localStorage.getItem("accessId")) ? (
                        <p
                          style={{
                            fontWeight: "500",
                            fontSize: "18px",
                            color: "green",
                          }}
                        >
                          Activated
                        </p>
                      ) : (
                        <Button
                          style={{
                            width: "fit-content",
                            background: "#2A3DA3",
                          }}
                          onClick={() => {
                            handleClick(item.id);
                            localStorage.setItem("accessId", item.id);
                            if (!localStorage.getItem("duplicateRole")) {
                              localStorage.setItem(
                                "duplicateRole",
                                localStorage.getItem("role")
                              );
                            }
                            if (
                              item.trusteeUser &&
                              item.trusteeUser[0] &&
                              item.trusteeUser[0].role
                            ) {
                              localStorage.setItem(
                                "role",
                                JSON.stringify(item.trusteeUser[0].role.name)
                              );
                            }

                            dispatch(setActivated(!activated));
                            getClientList();
                          }}
                        >
                          Access Now
                        </Button>
                      )
                    ) : (
                      <p
                        style={{
                          fontWeight: "500",
                          fontSize: "18px",
                          color: "green",
                        }}
                      >
                        Activated
                      </p>
                    )}
                  </div>
                </Col>
              ))}
            {!isInitialLoading &&
              inviteList &&
              inviteList.map((item, index) => (
                <Col
                  key={index}
                  className="DelegateCard"
                  style={{ height: "fit-content" }}
                >
                  <div className="DelegateClientSection">
                    <p className="DelegateHeading">{item.name}</p>
                  </div>
                  <div className="DelegateClientSection">
                    <p className="DelegateHeading">Modules I Can Access</p>
                  </div>
                  <p
                    className="DelegateSubHeading"
                    style={{ margin: "2rem 2rem" }}
                  >
                    Death (When I Die)
                  </p>
                  <div
                    className="DelegateClientSection"
                    style={{
                      marginTop: "8px",
                      gap: "1rem",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      style={{ width: "fit-content", background: "#09A84D" }}
                      onClick={() => {
                        if (
                          item.contacts &&
                          item.contacts[0] &&
                          item.contacts[0].invites &&
                          item.contacts[0].invites[0] &&
                          item.contacts[0].invites[0].invititationCode
                        ) {
                          handleAccept(
                            item.contacts[0].invites[0].invititationCode
                          );
                        }
                      }}
                    >
                      Accept Invite
                    </Button>
                    <Button
                      style={{
                        width: "fit-content",
                        background: "#2A3DA3",
                        opacity: "0.5",
                        cursor: "not-allowed",
                        // pointerEvents:"none"
                      }}
                    >
                      Access Now
                    </Button>
                  </div>
                </Col>
              ))}
          </Row>
        </Col>
        </Row>
      </div>
    </div>
  );
};

export default DelegateAccess;
